<i18n src="@/locales/modules/RoleTranslate.json"></i18n>

<template>
	<CbsContextMenu
		v-if="role.can_delete || role.can_update || mixinIsCanCreateTitle"
		v-bind="$attrs"
		:class="['role-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'role-context-menu-list' }"
	>
		<div v-if="mixinIsCanCreateTitle" class="role-context-menu-list__item pr-16 text-black flex items-center whitespace-no-wrap" @click="$emit('onClickManageTitle', role)">
			<i class="nucleo mr-3 nucleo-badge-14-2" />
			{{ $t("Title") }}
		</div>
		<div v-if="role.can_update" class="role-context-menu-list__item pr-16 text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', role)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>

		<div v-if="role.can_delete" class="role-context-menu-list__item pr-16 text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDelete', role)">
			<i class="nucleo mr-3 nucleo-trash-can" />
			{{ $t("Actions.Delete") }}
		</div>
	</CbsContextMenu>
	<span v-else></span>
</template>

<script>
import { titlePermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "RoleContextMenu",
	mixins: [
		getUserPermissions({
			...titlePermissions
		})
	],
	components: { CbsContextMenu },
	props: {
		role: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickDelete: {},
		onClickManageTitle: {}
	}
};
</script>

<style lang="scss" scoped>
.role-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.role-context-menu-list {
	.role-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
